/** Marker colour helpers shared by the canvas + overlay. */

/** Colour by device type — used in edit mode. */
export const DEVICE_TYPE_COLORS: Record<string, string> = {
  ground_settlement: "#0d6efd",
  building_settlement: "#ffc107",
  utility_settlement: "#FF9800",
  ground_water: "#44aaff",
  piezometer: "#44aaff",
  standpipe: "#44aaff",
  crack: "#ff44aa",
  tilting: "#dc3545",
  vibration: "#888888",
  movement: "#10b981",
  ground_movement: "#10b981",
  building_movement: "#059669",
  utility_movement: "#34d399",
};

export function colorForType(type: string): string {
  return DEVICE_TYPE_COLORS[type] || "#0d6efd";
}

/** Colour by alert status — used in read-only overview mode. */
export function colorForStatus(status?: string): string {
  switch (status) {
    case "action3":
      return "#8b0000";
    case "action2":
      return "#c0392b";
    case "action1":
    case "action":
      return "#dc3545";
    case "alarm":
      return "#fd7e14";
    case "alert":
      return "#ffc107";
    default:
      return "#28a745";
  }
}

export const DEVICE_TYPE_LABELS: Record<string, string> = {
  ground_settlement: "Ground Settlement",
  building_settlement: "Building Settlement",
  utility_settlement: "Utility Settlement",
  ground_water: "Ground Water",
  piezometer: "Piezometer",
  standpipe: "Standpipe",
  crack: "Crack Gauge",
  tilting: "Tilting",
  vibration: "Vibration",
  movement: "Movement",
  ground_movement: "Ground Movement",
  building_movement: "Building Movement",
  utility_movement: "Utility Movement",
};

export function labelForType(type: string): string {
  return DEVICE_TYPE_LABELS[type] || type;
}
